import { BestSeller, OnlineExclusive } from '@components/icons'
import { TFunction, useTranslation } from 'next-i18next/pages'
import s from './ProductTagBadge.module.scss'

interface Props {
    variant: 'bestSeller' | 'onlineExclusive' | undefined
}

const renderBestSeller = (t: TFunction) => (
    <>
        <BestSeller />
        <span className={s['product-tag']}>{t('Best Seller')}</span>
    </>
)

const renderOnlineExclusive = (t: TFunction) => (
    <>
        <OnlineExclusive />
        <span className={s['product-tag']}>{t('Online Exclusive')}</span>
    </>
)

const ProductTagBadge = ({ variant }: Props): React.ReactElement | null => {
    const { t } = useTranslation('pdp')

    if (variant === 'bestSeller') {
        return renderBestSeller(t)
    }

    if (variant === 'onlineExclusive') {
        return renderOnlineExclusive(t)
    }

    return null
}

export default ProductTagBadge
